import { styled } from 'styled-components';

import { Button } from '@vivaahealth/design-system';

import { AsYouType } from 'libphonenumber-js';

interface Props {
  schedulingLink?: string;
  practicePhoneNumber: string;
  fullWidth: boolean;
}

export const VirtualVisitButton: React.FC<
  Omit<Props, 'practicePhoneNumber'>
> = ({ schedulingLink, fullWidth }) => {
  if (!schedulingLink) return null;
  return (
    <ScheduleLink
      className="text-decoration-none text-white"
      target={'_blank'}
      href={schedulingLink}
    >
      <ScheduleButton fullWidth={fullWidth} variant="outlined">
        Virtual Visit Check-in
      </ScheduleButton>
    </ScheduleLink>
  );
};

const ScheduleAppointmentButton: React.FC<Props> = ({
  schedulingLink,
  practicePhoneNumber,
  fullWidth,
}) => {
  const formattedPhoneNumber = new AsYouType('US').input(practicePhoneNumber);
  return (
    <>
      {schedulingLink && schedulingLink !== '' ? (
        <ScheduleLink
          className="text-decoration-none text-white"
          target={'_blank'}
          href={schedulingLink}
        >
          <ScheduleButton fullWidth={fullWidth} variant="primary">
            Schedule appointment
          </ScheduleButton>
        </ScheduleLink>
      ) : (
        <PhoneNumber href={`tel:${practicePhoneNumber}`}>
          <ScheduleButton
            fullWidth={fullWidth}
            variant="primary"
          >{`Call ${formattedPhoneNumber}`}</ScheduleButton>
        </PhoneNumber>
      )}
    </>
  );
};

export default ScheduleAppointmentButton;

const PhoneNumber = styled.a`
  text-decoration: none !important;
  color: white !important;
  font-size: 14px !important;
`;

const ScheduleLink = styled.a`
  text-decoration: none !important;
  color: white !important;
  font-size: 14px !important;
`;

const ScheduleButton = styled(Button)`
  min-width: 198px;
  font-size: 14px !important;
`;
